//= Functions & Modules
// Own
import { Client } from './Client';

export function getGlobalClient(): Client {
    return window.g_client;
}
